module.exports = __webpack_public_path__ + "static/media/instant-booking-ribbon.03af1337.svg";